import { render, staticRenderFns } from "./AcknowledgeBackorderModal.vue?vue&type=template&id=e65d74f8&"
import script from "./AcknowledgeBackorderModal.vue?vue&type=script&lang=js&"
export * from "./AcknowledgeBackorderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports